/**
 * Texto de um medicamento na receita.
 *
 * Composição: "Amoxicilina 875mg + Clavulanato de potássio 125mg, Comprimido
 * revestido". Marca: nome com a embalagem ("Clavulin 875mg + 125mg Comprimido
 * revestido (14un)"). Texto livre: o que foi digitado.
 */
export function drugName(data) {
  const title = data.title || data.name;
  if (data.physicalForm && !data.caption) return `${title}, ${data.physicalForm}`;
  return `${title} ${data.caption || ''}`.trim();
}

export function stripeTitle(stripe) {
  if (stripe === 'Vermelho') return 'Tarja vermelha';
  if (stripe === 'Preto') return 'Tarja preta';
  if (stripe === 'Livre') return 'Venda livre';
  return '';
}
